import { Icon } from "@chakra-ui/react";
import React from "react";

const CircleOutlineIcon = (props) => (
  <Icon viewBox="0 0 5 5" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="1">
      <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
      <circle cx="2.5" cy="2.5" r="2" fill="none" />
    </g>
  </Icon>
);

export default React.memo(CircleOutlineIcon);
